import moment from 'moment';
import React, { Component } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Tooltip } from 'reactstrap';
import language from '../../../assets/languages/language';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import { showFailure, showInformation } from '../../../common/toast';
import { messages } from '../../../common/messages';
import { DIVISOR_FOR_CASES } from '../../../common/constant';
import { generateRandomInteger } from '../../../common/function';
/* eslint-disable*/

class Cfa2_2023Quizzes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      idname: '',
      chapters: '',
      all_checked_state: true,
      radio_checked_question: 0,
      quizPriorityLevel: 'none',
      single_clicked_val: '',
      getallabondQuiz: '',
      getallcompleteQuiz: '',
      quiz_length_state: '',
      caseId: [],
      caseQuestion: [],
      caseQuestionNextval: [],
      display_loader: 'show_block',
      deleteItemId: '',
      alert_status: false,
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRM}`,
      tooltips: [
        {
          placement: `${language.LC().SELECT_HERE_NUMBER}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().ALL_INCOMPLETE_QUIZ}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().SEE_THE_DETAILS}`,
          text_align: 'left',
        },
        {
          placement: `${messages.QUIZ_PRIORITY}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().UNANSWERED_QUIZ_SELECTED}`,
          text_align: 'left',
        },
      ],
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidMount() {
    window.scroll(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025question_bank/getChapters', data).then(resp => {
      const { success, chapters } = resp;
      if (success) {
        this.setState({ ValidToken: true, chapters });
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });

    this.abandonedQuizzes(data);

    FD.callAPI(App_data.backend_api + '/cfa_2_2025quizes/getallQuiz_length', data).then(
      resp_quiz_length => {
        const { success, quiz_length } = resp_quiz_length;
        if (success) {
          this.setState({ quiz_length_state: quiz_length });
        }
      },
    );
  }

  abandonedQuizzes = async data => {
    //console.log("abandonedQuizzes", data);
    await FD.callAPI(App_data.backend_api + '/cfa_2_2025quizes/getallQuiz', data).then(resp => {
      if (resp.success) {
        var getallabondQuiz = [];
        var completed_quiz = [];
        var dataString = JSON.stringify(resp.getallQuiz);
        var dataReason = JSON.parse(dataString);
        if (!dataReason.length) {
          this.setState({ display_loader: 'hide_block' });
        }
        for (var i = 0; i < dataReason.length; i++) {
          if (dataReason[i].count_tot === dataReason[i].number_questions) {
            completed_quiz.push(dataReason[i]);
          } else {
            getallabondQuiz.push(dataReason[i]);
          }
          if (i === dataReason.length - 1) {
            this.setState({ display_loader: 'hide_block' });
          }
        }
        this.setState({
          getallabondQuiz: getallabondQuiz,
          getallcompleteQuiz: completed_quiz,
        });
      } else {
        //console.log("Some Thing Went Wrong");
      }
      return resp;
    });
  };

  _all_Checked = () => {
    var checkboxes = document.getElementsByName('approve[]');
    var all_Checked = document.getElementById('all_Checked');
    if (all_Checked.checked) {
      this.setState({ all_checked_state: true }, function all_checked_state() {
        var i = 0;
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = '';
        }
      });
    } else {
      this.setState({ all_checked_state: false }, function all_checked_state() {
        var i = 0;
        for (i = 0; i < checkboxes.length; i++) {
          checkboxes[i].checked = 'FALSE';
        }
      });
    }
  };

  _single_Checked = () => {
    var checkboxes = document.getElementsByName('approve[]');
    var i = 0;
    var single_clicked_value = [];
    for (i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        single_clicked_value.push(checkboxes[i].value);
      }
    }
    this.setState({
      all_checked_state: false,
      single_clicked_val: single_clicked_value,
    });
  };

  _createQuiz() {
    this.setState({ display_loader: 'show_block' });
    this.setState({ caseId: [] });
    this.setState({ caseQuestion: [] });
    var question_length_val = document.querySelector('input[name="number_questions"]:checked')
      .value;
    var timer_value,
      selectedChapter,
      caselength = '';
    timer_value = this.state.quiz_length_state[this.state.radio_checked_question].timer_value;

    if (this.state.all_checked_state) {
      selectedChapter = this.state.chapters.map(val => {
        return val.id;
      });
    } else {
      var checkboxes = document.getElementsByName('approve[]');
      var i = 0;
      var single_clicked_value = [];
      // if (this.state.single_clicked_val === '') {
      for (i = 0; i < checkboxes.length; i++) {
        if (checkboxes[i].checked) {
          single_clicked_value.push(checkboxes[i].value);
        }

        // }
        selectedChapter = single_clicked_value;
      }
    }
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      priority: this.state.quizPriorityLevel,
      selectedChapter,
    };
    FD.callAPI(App_data.backend_api + '/cfa_2_2025quizes/getRandomCases', data).then(resp => {
      if (resp.success) {
        var allCasesid_arr = [];
        for (var i = 0; i < resp.chaptersWiseCases.length; i++) {
          allCasesid_arr.push(resp.chaptersWiseCases[i].id);
        }
        if (allCasesid_arr.length < caselength) {
          showFailure(language.LC().CFA2_2025_QUIZ_ERROR);
          this.setState({ display_loader: 'hide_block' });
          return;
        }
        var allCasesid = getRandomValues(allCasesid_arr, question_length_val / 6);
        function getRandomValues(arr, count) {
          var result = [];
          var _tmp = arr.slice();
          for (var i = 0; i < count; i++) {
            var index = generateRandomInteger(1, 10) % _tmp.length; 
            result.push(_tmp.splice(index, 1)[0]);
          }
          return result;
        }
        this.setState({ caseId: [] });
        this.setState({ caseQuestion: [] });
        let chaptersWiseCasesQuestionCount = 0;

        for (var j = 0; j < allCasesid.length; j++) {
          var dataparam = {
            token: this.state.token,
            idname: this.state.idname,
            casesId: allCasesid[j],
          };
          var k = 0;
          FD.callAPI(
            App_data.backend_api + '/cfa_2_2025quizes/getCasesquearraybyId',
            dataparam,
          ).then(respquestion => {
            var qid = {};
            const questionCount = respquestion.chapterswisecases && respquestion.chapterswisecases.length > 0 ? respquestion.chapterswisecases.length : 0;
            chaptersWiseCasesQuestionCount += questionCount;

            for (var l = 0; l < respquestion.chapterswisecases.length; l++) {
              qid[l] = respquestion.chapterswisecases[l].id;
            }
            var caseIdjoined = this.state.caseId.concat(respquestion.caseId);
            var questionJoined = '';
            questionJoined = this.state.caseQuestion.concat(qid);
            this.setState({ caseQuestion: questionJoined, caseId: caseIdjoined }, function () {
              //console.log(this.state);
              if (k === allCasesid.length - 1) {
                const { caseId, caseQuestion, idname, token } = this.state;
                const casesId = caseId; // This should be an array like [17,49,89]
                const questionStats = JSON.stringify(caseQuestion);

                const allCasesLength = question_length_val / DIVISOR_FOR_CASES;

                if (allCasesLength !== casesId.length) {
                  showInformation(messages.NON_ATTEMPTED_QUIZ);
                  this.setState({ display_loader: 'hide_block' });
                  return;
                }

                var data = {
                  token,
                  idname,
                  number_questions: chaptersWiseCasesQuestionCount,
                  // number_questions: question_length_val, // it makes incorrect questions count
                  case_id: JSON.stringify(casesId),
                  questions: questionStats,
                  timer_value: timer_value,
                };
                //console.log(data);
                FD.callAPI(App_data.backend_api + '/cfa_2_2025quizes/createQuiz', data).then(
                  resp => {
                    if (resp.success) {
                      this.setState({ display_loader: 'hide_block' });
                      this.context.router.push({
                        pathname: `/cfa2/2026/beforestart/${resp.last_id}/`,
                        state: {
                          token: this.state.token,
                          idname: this.state.idname,
                          quiz_id: resp.last_id,
                          status_send: '',
                        },
                      });
                    } else {
                      //console.log(resp.success);
                    }
                  },
                );
              }
            });
            k++;
          });
        }
      } else {
        showInformation(messages.CASES_NOT_AVAILABLE);
        this.setState({ display_loader: 'hide_block' });
      }
    });
  }

  _checkAbondon(items, e) {
    this.context.router.push({
      pathname: `/cfa2/2026/beforestart/${items.id}/${'abondon'}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: items.id,
        status_send: 'abondon',
      },
    });
  }

  prioritySelected = e => {
    this.setState({ quizPriorityLevel: e.target.value });
  };
  _checkCompleted(items, e) {
    this.context.router.push({
      pathname: `/cfa2/2026/beforestart/${items.id}/${'completed'}`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        quiz_id: items.id,
        status_send: 'completed',
      },
    });
  }

  _length_Checked(items, index_value, e) {
    this.setState({ radio_checked_question: index_value });
  }

  deleteQuizzes = (items, e) => {
    //console.log("deleteQuizzes", items);
    if (!this.state.alert_status) {
      this.setState({
        deleteItemId: items.id,
        alert_status: true,
      });
    } else {
      this.setState({
        deleteItemId: '',
        alert_status: false,
      });
    }
  };

  deleteToggleDone = async e => {
    //console.log("calllinggg!!!!");
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      deleteItemId: this.state.deleteItemId,
    };
    await FD.callAPI(App_data.backend_api + '/cfa_2_2025quizes/deleteAbandonedQuizzes', data).then(
      async resp => {
        if (resp.success) {
          await this.abandonedQuizzes(data);
          this.setState({
            deleteItemId: '',
            alert_status: false,
          });
        }
      },
    );
  };

  render() {
    const { tooltips, quizPriorityLevel, chapters } = this.state;
    let chapters_all = chapters;
    let chapter_data = '';
    if (this.state.chapters.length) {
      chapter_data = chapters_all.map((items, index) => (
        <div className='col-md-6' key={index}>
          <label className='check_container'>
            {items.chapter_name}
            <input
              type='checkbox'
              name='approve[]'
              value={items.id}
              onClick={this._single_Checked.bind(this)}
            />
            <span className='checkmark' />
          </label>
        </div>
      ));
    }

    let abandoned_all = this.state.getallabondQuiz;
    let abandoned_data = '';

    if (this.state.getallabondQuiz.length) {
      abandoned_data = abandoned_all.map((items, index) => (
        <tr key={index}>
          <td className='text_red'>
            <strong>
              {language.LC().ID}: {items.id}
            </strong>
          </td>
          <td>
            {language.LC().QUESTIONS}: {items.number_questions}
          </td>
          <td>
            {language.LC().DATE}: <Dateform created_d={items.createdAt} />
          </td>
          <td className='text_blue'>
            <span className='cursor_pointer' onClick={this._checkAbondon.bind(this, items)}>
              {language.LC().RECOVER}
            </span>
          </td>
          <td className=''>
            <span className='delete-quizzes' onClick={() => this.deleteQuizzes(items)}>
              {' '}
              <i className='fa fa-trash' aria-hidden='true' /> Delete{' '}
            </span>
          </td>
        </tr>
      ));
    } else {
      abandoned_data = (
        <tr contentEditable="false">
          <td colSpan={4} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    let getallcompleteQuiz_all = this.state.getallcompleteQuiz;
    let getallcompleteQuiz_data = '';

    if (this.state.getallcompleteQuiz.length) {
      getallcompleteQuiz_data = getallcompleteQuiz_all.map((items, index) => (
        <tr key={index} className='quize-row'>
          <td className='text_green'>
            <strong>
              {language.LC().ID}: {items.id}
            </strong>
          </td>
          <td>
            {language.LC().QUESTIONS}: {items.number_questions}
          </td>
          <td>
            {language.LC().DATE}: <Dateform created_d={items.createdAt} />
          </td>
          <td className='text_blue'>
            <span className='cursor_pointer' onClick={this._checkCompleted.bind(this, items)}>
              {language.LC().VIEW}
            </span>
          </td>
        </tr>
      ));
    } else {
      getallcompleteQuiz_data = (
        <tr contentEditable="false">
          <td colSpan={4} className="text-center">
            No Data Found
          </td>
        </tr>
      );
    }

    let quiz_length_state_all = this.state.quiz_length_state;
    let quiz_length_state_data = '';
    if (this.state.quiz_length_state.length) {
      quiz_length_state_data = quiz_length_state_all.map((items, index) => (
        <label className='radio_container' key={index}>
          <span>{items.quiz_length / 6}</span>
          <span>{language.LC().CASES}</span>
          <input
            type='radio'
            id='number_questions_id'
            name='number_questions'
            value={items.quiz_length}
            checked={this.state.radio_checked_question === index}
            onClick={this._length_Checked.bind(this, items, index)}
          />
          <span className='checkmark' />
        </label>
      ));
    }

    return (
      <div className='animated fadeIn'>
        {/* <div className="row">
          <div className="col-md-8 margin_bottom_20"> */}
        <div className='margin_bottom_20 d-flex justify-content-between'>
          <h1 className='section_head'> {language.LC().CFA_LEVEL_II_QUIZZES} </h1>
          {/* </div>
          <div className="col-md-4 text-md-right margin_bottom_20"> */}
          <button className='btn btn-primary pointer_class' onClick={this._createQuiz.bind(this)}>
            {' '}
            {language.LC().CREATE_QUIZ}{' '}
          </button>
          {/* </div> */}
        </div>
        <div className='row'>
          <div className='col-lg-7'>
            <div className='card'>
              <div className='card-header'>
                {language.LC().CONTENT}
                <div className='card-actions float-right'>
                  <label className='check_container margin_bottom_0'>
                    {' '}
                    {language.LC().ALL_CHAPTERS}
                    <input
                      type='checkbox'
                      id='all_Checked'
                      name='all_checked'
                      value='select'
                      onClick={this._all_Checked.bind(this)}
                      checked={this.state.all_checked_state}
                    />
                    <span className='checkmark' />
                  </label>
                </div>
              </div>
              <div className='card-block padding_15'>
                <div className='row'>{chapter_data}</div>
              </div>
            </div>

            <div className='card'>
              <div className='card-header'>
                {language.LC().ABANDONED_QUIZZES}
                <div className='card-actions card_action_tooltip float-right'>
                  <TooltipItem
                    key='1'
                    id='1'
                    content={this.state.tooltips[1].placement}
                    place_tip={this.state.tooltips[1].text_align}
                  />
                </div>
              </div>
              <div className='table_responsive_wrapper abandoned_quizzes_cards_scroll'>
                <div className='table-responsive'>
                  <table className='table_white_bg table'>
                    <tbody>{abandoned_data}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-5'>
            <div className='card'>
              <div className='card-header'>
                {messages.FILTER_QUIZZES}
                <div className='card-actions card_action_tooltip float-right'>
                  <TooltipItem
                    key='3'
                    id='3'
                    content={tooltips[3].placement}
                    place_tip={tooltips[3].text_align}
                  />
                </div>
              </div>
              <div className='card-block'>
                <label className='radio_container'>
                  {' '}
                  {messages.NONE}
                  <input
                    type='radio'
                    id='none'
                    name='none'
                    value='none'
                    checked={quizPriorityLevel === 'none'}
                    onClick={this.prioritySelected}
                  />
                  <span className='checkmark' />
                </label>
                <label className='radio_container'>
                  {messages.NON_ATTEMPTED_CASES}
                  <input
                    type='radio'
                    id='mark_unanswered'
                    name='mark_unanswered'
                    value='unanswered'
                    checked={quizPriorityLevel === 'unanswered'}
                    onClick={this.prioritySelected}
                  />
                  <span className='checkmark' />
                </label>
                <div className='card-actions card_action_tooltip float-right tooltip_quiz'>
                  <TooltipItem
                    key='4'
                    id='4'
                    content={tooltips[4].placement}
                    place_tip={tooltips[4].text_align}
                  />
                </div>
              </div>
            </div>
            <div className='card'>
              <div className='card-header'>
                {language.LC().LENGTH}
                <div className='card-actions card_action_tooltip float-right'>
                  <TooltipItem
                    key='0'
                    id='0'
                    content={this.state.tooltips[0].placement}
                    place_tip={this.state.tooltips[0].text_align}
                  />
                </div>
              </div>
              <div className='card-block'>{quiz_length_state_data}</div>
            </div>
            <div className='card'>
              <div className='card-header'>
                {language.LC().COMPLETED_QUIZZES}
                <div className='card-actions card_action_tooltip float-right'>
                  <TooltipItem
                    key='2'
                    id='2'
                    content={this.state.tooltips[2].placement}
                    place_tip={this.state.tooltips[2].text_align}
                  />
                </div>
              </div>
              <div className='table_responsive_wrapper'>
                <div className='table-responsive'>
                  <table className='table_white_bg table'>
                    {/*<thead>    											
										<tr>
							                <th></th>
							                <th></th>
							                <th></th>
							                <th></th>
										</tr>
									</thead>*/}
                    <tbody>{getallcompleteQuiz_data}</tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {/*<div className="col-sm-4"> 
					<div className="card">
					    <div className="card-header">
					      Other Options
					      <div className="card-actions card_action_tooltip">
					      </div>
					    </div>
					    <div className="card-block">
					    	<div className="checkbox checkbox-info checkbox-circle">
					    		<div>
			                        <input type="checkbox" value="1"  name="include_timer" checked={this.state.include_timer} onClick={this._changeIncludetimer.bind(this)}/>
			                        <label htmlFor="checkbox8">
			                          Include A Timer
			                        </label>
		                        </div>
		                        <div>
			                        <input type="checkbox" value="1"  name="save_results" checked={this.state.save_results} onClick={this._changeSaveresult.bind(this)}/>
			                        <label htmlFor="checkbox8">
			                          Save My Results
			                        </label>
		                        </div>		                        
		                    </div>				        
					    </div>
				  	</div> 
				</div>*/}
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.deleteQuizzes}
            className={'modal-primary ' + this.props.className}
          >
            <ModalHeader>
              {language.LC().ALERT}
              <Button className='close' color='secondary' onClick={this.deleteQuizzes}>
                ×
              </Button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.deleteToggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>

        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          alt=''
          className=''
          width='18'
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

function Dateform(props) {
  var myDate = moment(props.created_d).format('YYYY-MM-DD');
  return <span>{myDate}</span>;
}

export default Cfa2_2023Quizzes;



// WEBPACK FOOTER //
// ./src/views/CFA2-2025/Quizzes/Cfa2_2023Quizzes.js